import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getProductsBybrand } from "../ApiService/Brand/productbrand";
import { fetchlogo } from "../ApiService/logo/logo";
import { logoutUser } from "../ApiService/logoutapi/logoutapi";
import { getProductsByCategory } from "../ApiService/productcategory/productcategory";
import { getProductsBysubCategory } from "../ApiService/productsubcatagory/productsubcategory";
import client from "../assets/images/client/16.jpg";
import ctaImg from "../assets/images/cta.png";
import { CategoryContext } from "../components/CategoryContext";
import LanguageSelector from "./LanguageSelector";
import axios from "axios";
import toast from "react-hot-toast";

import {
  FaRupeeSign,
  FiChevronDown,
  FiChevronUp,
  FiHeart,
  FiHelpCircle,
  FiLogOut,
  FiSearch,
  FiShoppingCart,
  FiUser,
} from "../assets/icons/vander";

// Helper functions for safe data access
const safeGet = (obj, path, fallback = "") => {
  return path.split(".").reduce((acc, part) => {
    return acc && acc[part] ? acc[part] : fallback;
  }, obj);
};

const validateArray = (arr) => {
  return Array.isArray(arr) ? arr : [];
};

// Skeleton Loading Component for Logo
const LogoSkeleton = () => (
  <div className="h-[50px] w-[150px] bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse flex items-center justify-center">
    <div className="h-4 w-8 bg-gray-300 dark:bg-gray-600 rounded-full"></div>
  </div>
);

// Error Boundary Component
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error caught by boundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center">
          Something went wrong. Please refresh.
        </div>
      );
    }
    return this.props.children;
  }
}

export default function Navbar({ navClass, navlight }) {
  let [isToggle, setToggle] = useState(false);
  let [manu, setManu] = useState("");
  let [subManu, setSubManu] = useState("");
  let [isOpen, setIsOpen] = useState(false);
  let [cartManu, setCartManu] = useState(false);
  let [userManu, setUserManu] = useState(false);
  let dropdownRef = useRef(null);
  let cartRef = useRef(null);
  let userRef = useRef(null);

  // Mobile accordion states
  const [mobileShopOpen, setMobileShopOpen] = useState(false);
  const [mobileWhoWeAreOpen, setMobileWhoWeAreOpen] = useState(false);
  const [mobilePoliciesOpen, setMobilePoliciesOpen] = useState(false);

  const { t } = useTranslation();

  // Initialize context with safe defaults
  const contextValue = useContext(CategoryContext) || {
    categories: [],
    brand: [],
    subcategories: [],
    loading: false,
    error: null,
  };

  const { categories, brand, subcategories, loading, error } = contextValue;
  const BASE_MEDIA_URL = process.env.REACT_APP_MEDIA_BASE_URL;

  // Initialize state with safe defaults
  const [logos, setlogos] = useState({ header_logo: "" });
  const [isLogoLoading, setIsLogoLoading] = useState(true);
  const [catproducts, setcatProducts] = useState([]);
  const [subcatproducts, setsubcatProducts] = useState([]);
  const [brandproduct, setbrandproduct] = useState([]);
  const [file, setFile] = useState(client);
  const [customerDetails, setCustomerDetails] = useState({});

  const navigate = useNavigate();

  const customerId = localStorage.getItem("customer_id");

  const fetchProfile = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/profile/?customer_id=${customerId}`
      );
      setCustomerDetails(response.data.customer_details);

      // Set profile picture if available
      if (response.data.customer_details.profile_picture) {
        setFile(
          BASE_MEDIA_URL + response.data.customer_details.profile_picture
        );
      }
    } catch (error) {
      console.error("Failed to fetch profile:", error);
      setFile(client);
    }
  };

  useEffect(() => {
    if(customerId){
      fetchProfile();
    }
  }, []);

  // Safe user data access
  const userName = customerDetails.first_name
    ? customerDetails.first_name
    : "User";

  const handleCategoryClick = async (categoryId) => {
    if (!categoryId) {
      toast.error("Invalid category ID");
      return;
    }

    try {
      const data = await getProductsByCategory(categoryId);
      setcatProducts(validateArray(data));
      navigate(`/shop-grid-left-sidebar/category/${categoryId}`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load products");
    }
  };

  const handlesubCategoryClick = async (subcategoryId) => {
    if (!subcategoryId) {
      toast.error("Invalid subcategory ID");
      return;
    }

    try {
      const data = await getProductsBysubCategory(subcategoryId);
      setcatProducts(validateArray(data));
      navigate(`/shop-grid-left-sidebar/subcategory/${subcategoryId}`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load products");
    }
  };

  const handlepbrandClick = async (brandId) => {
    if (!brandId) {
      toast.error("Invalid brand ID");
      return;
    }

    try {
      const data = await getProductsBybrand(brandId);
      setbrandproduct(validateArray(data));
      navigate(`/shop-grid-left-sidebar/brand/${brandId}`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load products");
    }
  };

  useEffect(() => {
    const getlogo = async () => {
      setIsLogoLoading(true);
      try {
        const Logos = await fetchlogo();
        if (Logos && Logos[0] && Logos[0].header_logo) {
          setlogos(Logos[0]);
        } else {
          setlogos({ header_logo: "" });
        }
      } catch (err) {
        console.error("Failed to load logo:", err);
        setlogos({ header_logo: "" });
      } finally {
        setIsLogoLoading(false);
      }
    };
    getlogo();
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    const cartOutsideClick = (event) => {
      if (cartRef.current && !cartRef.current.contains(event.target)) {
        setCartManu(false);
      }
    };
    const userOutsideClick = (e) => {
      if (userRef.current && !userRef.current.contains(e.target)) {
        setUserManu(false);
      }
    };
    window.addEventListener("click", handleOutsideClick);
    window.addEventListener("click", cartOutsideClick);
    window.addEventListener("click", userOutsideClick);

    let current = window.location.pathname;
    setManu(current);
    setSubManu(current);
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
      window.removeEventListener("click", cartOutsideClick);
      window.removeEventListener("click", userOutsideClick);
    };
  }, []);

  const toggleMenu = () => {
    setToggle(!isToggle);
  };

  const handleLogout = async () => {
    try {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const refreshtocken = localStorage.getItem("refresh_token");

      if (!refreshtocken) {
        console.warn("No customer ID found in local storage");
      }

      await logoutUser(refreshtocken);

      toast.success("Logged out successfully!", {
        position: "top-center",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });

      localStorage.clear();
      sessionStorage.clear();

      setTimeout(() => navigate("/login"), 1000);
    } catch (error) {
      // toast.error("Logout failed. Please try again.", {
      //     position: "top-center",
      //     style: {
      //         borderRadius: "10px",
      //         background: "#333",
      //         color: "#fff",
      //     },
      // });

      // wrong apporch

      toast.success("Logged out successfully!", {
        position: "top-center",
        style: {
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        },
      });

      localStorage.clear();
      sessionStorage.clear();

      setTimeout(() => navigate("/login"), 1000);
    }
  };

  return (
    <ErrorBoundary>
      <nav
        id="topnav"
        className={`${navClass} mb-0 pb-0 md:sticky md:top-0 md:z-50 md:bg-white dark:md:bg-slate-900 md:shadow-md h-[70px]`}
      >
        <div className="container relative h-full flex">
          {navlight === true ? (
            <Link className="logo" to="/">
              <span className="inline-block dark:hidden">
                {isLogoLoading ? (
                  <LogoSkeleton />
                ) : logos.header_logo ? (
                  <img
                    src={`${BASE_MEDIA_URL}${logos.header_logo}`}
                    className="h-[90px]"
                    alt="logo light"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : (
                  <div className="h-[80px] flex items-center justify-center text-gray-500">
                    <span>Sportyfi</span>
                  </div>
                )}
              </span>
              {logos.header_logo ? (
                <img
                  src={`${BASE_MEDIA_URL}${logos.header_logo}`}
                  className="h-[90px] hidden dark:inline-block"
                  alt="logo dark"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ) : (
                <div className="h-[90px] hidden dark:flex items-center justify-center text-gray-500">
                  <span>Sportyfi</span>
                </div>
              )}
            </Link>
          ) : (
            <Link className="logo" to="/">
              <div>
                {isLogoLoading ? (
                  <LogoSkeleton />
                ) : logos.header_logo ? (
                  <img
                    src={`${BASE_MEDIA_URL}${logos.header_logo}`}
                    className="h-[90px] inline-block dark:hidden"
                    alt="logo light"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : (
                  <div className="h-[90px] flex items-center justify-center text-gray-500">
                    <span>Sportyfi</span>
                  </div>
                )}
                {logos.header_logo ? (
                  <img
                    src={`${BASE_MEDIA_URL}${logos.header_logo}`}
                    className="h-[90px] hidden dark:inline-block"
                    alt="logo dark"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : (
                  <div className="h-[90px] hidden dark:flex items-center justify-center text-gray-500">
                    <span>Logo</span>
                  </div>
                )}
              </div>
            </Link>
          )}

          <div
            id="navigation"
            style={{ display: isToggle === true ? "block" : "none" }}
          >
            <ul className={`navigation-menu  text-black dark:text-white`}>
              <li className={`ms-0 ${manu === "/" ? "active" : ""}`}>
                <Link to="/" className="sub-menu-item px-2">
                  {t("Home")}
                </Link>
              </li>

              <li
                className={`${
                  manu === "/shop-grid-left-sidebar/allproducts" ? "active" : ""
                }`}
              >
                <Link
                  to="/shop-grid-left-sidebar/allproducts"
                  className="sub-menu-item px-1"
                >
                  Product
                </Link>
              </li>

              {/* Mobile Shop Accordion */}
              <li className={`md:hidden ${manu === "/shop" ? "active" : ""}`}>
                <div className=" border-slate-700 ml-1">
                  <button
                    className="flex justify-between items-center w-full py-3 text-left"
                    onClick={() => setMobileShopOpen(!mobileShopOpen)}
                  >
                    <span>Shop</span>
                    {mobileShopOpen ? (
                      <FiChevronUp className="text-xl" />
                    ) : (
                      <FiChevronDown className="text-xl" />
                    )}
                  </button>
                  {mobileShopOpen && (
                    <div className="pb-3 ml-1">
                      <ul className="pl-4">
                        <li className="mb-2 font-medium">Categories</li>
                        {loading ? (
                          <li>Loading...</li>
                        ) : error ? (
                          <li>Error: {error}</li>
                        ) : validateArray(categories).length > 0 ? (
                          validateArray(categories).map((category, index) => (
                            <li key={index} className="py-0 pl-4">
                              <button
                                className="sub-menu-item"
                                onClick={() =>
                                  handleCategoryClick(
                                    safeGet(category, "category_name_id")
                                  )
                                }
                              >
                                {safeGet(
                                  category,
                                  "category_name",
                                  "Unnamed Category"
                                )}
                              </button>
                            </li>
                          ))
                        ) : (
                          <li>No categories available</li>
                        )}

                        <li className="mb-2 mt-4 font-medium">Subcategories</li>
                        {loading ? (
                          <li>Loading...</li>
                        ) : error ? (
                          <li>Error: {error}</li>
                        ) : validateArray(subcategories).length > 0 ? (
                          validateArray(subcategories).map(
                            (subcatagoryNames, index) => (
                              <li key={index} className="py-0 pl-4">
                                <button
                                  className="sub-menu-item"
                                  onClick={() =>
                                    handlesubCategoryClick(
                                      safeGet(
                                        subcatagoryNames,
                                        "sub_category_details.sub_category_id"
                                      )
                                    )
                                  }
                                >
                                  {safeGet(
                                    subcatagoryNames,
                                    "sub_category_details.sub_category_name",
                                    "Unnamed Subcategory"
                                  )}
                                </button>
                              </li>
                            )
                          )
                        ) : (
                          <li>No subcategories available</li>
                        )}

                        <li className="mb-2 mt-4 font-medium">Brands</li>
                        {loading ? (
                          <li>Loading...</li>
                        ) : error ? (
                          <li>Error: {error}</li>
                        ) : validateArray(brand).length > 0 ? (
                          validateArray(brand).map((brandName, index) => (
                            <li key={index} className="py-0 pl-4">
                              <button
                                className="sub-menu-item"
                                onClick={() =>
                                  handlepbrandClick(
                                    safeGet(brandName, "brand_details.brand_id")
                                  )
                                }
                              >
                                {safeGet(
                                  brandName,
                                  "brand_details.brand_name",
                                  "Unknown Brand"
                                )}
                              </button>
                            </li>
                          ))
                        ) : (
                          <li>No brands available</li>
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </li>

              {/* Desktop Shop Menu */}
              <li
                className={`hidden md:block has-submenu parent-parent-menu-item ${
                  ["/detail-item", "/grid-item"].includes(manu) ? "active" : ""
                }`}
              >
                <Link
                  to="#"
                  onClick={() =>
                    setSubManu(subManu === "/shop-item" ? "" : "/shop-item")
                  }
                >
                  Shop
                </Link>
                <span className="menu-arrow"></span>
                <ul
                  className={`submenu megamenu max-w-[800px] mx-auto flex justify-between ${
                    ["/grid-item"].includes(subManu) ? "open" : ""
                  }`}
                >
                  <li className="ms-0">
                    <ul>
                      <li className="megamenu-head ms-0">Category</li>
                      {loading ? (
                        <li>Loading...</li>
                      ) : error ? (
                        <li>Error: {error}</li>
                      ) : validateArray(categories).length > 0 ? (
                        validateArray(categories).map((category, index) => (
                          <li key={index} className="ms-0 py-[4px]">
                            <button
                              className="sub-menu-item pl-5"
                              onClick={() =>
                                handleCategoryClick(
                                  safeGet(category, "category_name_id")
                                )
                              }
                            >
                              {safeGet(
                                category,
                                "category_name",
                                "Unnamed Category"
                              )}
                            </button>
                          </li>
                        ))
                      ) : (
                        <li>No categories available</li>
                      )}
                    </ul>
                  </li>

                  <li className="ms-0">
                    <ul>
                      <li className="megamenu-head ms-0">Subcatagory</li>
                      {loading ? (
                        <li>Loading...</li>
                      ) : error ? (
                        <li>Error: {error}</li>
                      ) : validateArray(subcategories).length > 0 ? (
                        validateArray(subcategories).map(
                          (subcatagoryNames, index) => (
                            <li key={index} className="ms-0 py-[4px]">
                              <button
                                className="sub-menu-item pl-5"
                                onClick={() =>
                                  handlesubCategoryClick(
                                    safeGet(
                                      subcatagoryNames,
                                      "sub_category_details.sub_category_id"
                                    )
                                  )
                                }
                              >
                                {safeGet(
                                  subcatagoryNames,
                                  "sub_category_details.sub_category_name",
                                  "Unnamed Subcategory"
                                )}
                              </button>
                            </li>
                          )
                        )
                      ) : (
                        <li>No subcategories available</li>
                      )}
                    </ul>
                  </li>

                  <li className="ms-0">
                    <ul>
                      <li className="megamenu-head ms-0">Brand</li>
                      {loading ? (
                        <li>Loading...</li>
                      ) : error ? (
                        <li>Error: {error}</li>
                      ) : validateArray(brand).length > 0 ? (
                        validateArray(brand).map((brandName, index) => (
                          <li key={index} className="ms-0 py-[4px]">
                            <button
                              className="sub-menu-item pl-5"
                              onClick={() =>
                                handlepbrandClick(
                                  safeGet(brandName, "brand_details.brand_id")
                                )
                              }
                            >
                              {safeGet(
                                brandName,
                                "brand_details.brand_name",
                                "Unknown Brand"
                              )}
                            </button>
                          </li>
                        ))
                      ) : (
                        <li>No brands available</li>
                      )}
                    </ul>
                  </li>

                  <li className="ms-0">
                    <ul>
                      <li className="megamenu-head">
                        <img src={ctaImg} alt="" />
                      </li>
                      <li className="text-center">
                        <Link
                          to="/shop-grid-left-sidebar/allproducts"
                          className="py-2 px-5 inline-block font-medium tracking-wide align-middle duration-500 text-base text-center bg-orange-500/10 text-green-500 rounded-md me-2 mt-2"
                        >
                          <i className="mdi mdi-cart-outline"></i> Shop Now
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li className={`${manu === "/Customize" ? "active" : ""}`}>
                <Link to="/Customize" className="sub-menu-item px-1">
                  Customize
                </Link>
              </li>

              <li className={`${manu === "/sale" ? "active" : ""}`}>
                <Link to="/sale" className="sub-menu-item px-1">
                  Sale
                </Link>
              </li>

              <li className={`${manu === "/contact" ? "active" : ""}`}>
                <Link to="/contact" className="sub-menu-item px-1">
                  Order us
                </Link>
              </li>

              {/* Mobile Who We Are Accordion */}
              <li className={`md:hidden ${manu === "/about" ? "active" : ""}`}>
                <div className=" border-slate-700 ml-1">
                  <button
                    className="flex justify-between items-center w-full py-3 text-left"
                    onClick={() => setMobileWhoWeAreOpen(!mobileWhoWeAreOpen)}
                  >
                    <span>Who We Are</span>
                    {mobileWhoWeAreOpen ? (
                      <FiChevronUp className="text-xl" />
                    ) : (
                      <FiChevronDown className="text-xl" />
                    )}
                  </button>
                  {mobileWhoWeAreOpen && (
                    <div className="pb-3">
                      <ul className="pl-4">
                        <li className="py-0">
                          <Link to="/aboutus" className="sub-menu-item">
                            About
                          </Link>
                        </li>

                        <li className="mb-2 mt-2 font-medium">Policies</li>
                        <li className="py-0 pl-4">
                          <Link to="/terms" className="sub-menu-item">
                            Term & conditions
                          </Link>
                        </li>
                        <li className="py-0 pl-4">
                          <Link to="/privacy" className="sub-menu-item">
                            Privacy policy
                          </Link>
                        </li>
                        <li className="py-0 pl-4">
                          <Link to="/refund" className="sub-menu-item">
                            Refund policy
                          </Link>
                        </li>
                        <li className="py-0 pl-4">
                          <Link to="/return" className="sub-menu-item">
                            Return
                          </Link>
                        </li>
                        <li className="py-0 pl-4">
                          <Link to="/Shipping" className="sub-menu-item">
                            Shipping policy
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </li>

              {/* Desktop Who We Are Menu */}
              <li
                className={`hidden md:block has-submenu parent-parent-menu-item px-1 ${
                  ["/shop-grid"].includes(manu) ? "active" : ""
                }`}
              >
                <Link
                  to="#"
                  onClick={() => setSubManu(subManu === "#" ? "" : "#")}
                >
                  Who We Are
                </Link>
                <span className="menu-arrow"></span>
                <ul
                  className={`submenu ${
                    ["/shop-grid"].includes(subManu) ? "open" : ""
                  }`}
                >
                  <li
                    className={`ms-0 pl-[10px] ${
                      manu === "/aboutus" ? "active" : ""
                    }`}
                  >
                    <Link to="/aboutus" className="sub-menu-item px-2">
                      About
                    </Link>
                  </li>
                  <li
                    className={`has-submenu parent-menu-item ms-0 ${
                      ["/terms"].includes(manu) ? "active" : ""
                    }`}
                  >
                    <Link
                      to="#"
                      onClick={() =>
                        setSubManu(setManu === "/grid-item" ? "" : "/grid-item")
                      }
                    >
                      Policies
                    </Link>
                    <span className="submenu-arrow"></span>
                    <ul
                      className={`submenu ${
                        ["/terms"].includes(subManu) ? "open" : ""
                      }`}
                    >
                      <li
                        className={`ms-0 ${manu === "/terms" ? "active" : ""}`}
                      >
                        <Link to="/terms" className="sub-menu-item">
                          Term & conditions
                        </Link>
                      </li>
                      <li
                        className={`ms-0 ${
                          manu === "/privacy" ? "active" : ""
                        }`}
                      >
                        <Link to="/privacy" className="sub-menu-item">
                          Privacy policy
                        </Link>
                      </li>
                      <li
                        className={`ms-0 ${manu === "/refund" ? "active" : ""}`}
                      >
                        <Link to="/refund" className="sub-menu-item">
                          Refund policy
                        </Link>
                      </li>
                      <li
                        className={`ms-0 ${manu === "/return" ? "active" : ""}`}
                      >
                        <Link to="/return" className="sub-menu-item">
                          Return
                        </Link>
                      </li>
                      <li
                        className={`ms-0 ${
                          manu === "/Shipping" ? "active" : ""
                        }`}
                      >
                        <Link to="/Shipping" className="sub-menu-item">
                          Shipping policy
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <ul className="buy-button flex pt-7 sm:pt-6 list-none mb-0">
            <li
              className="dropdown inline-block relative pt-0 sm:pt-2 pe-1"
              ref={dropdownRef}
            >
              <button
                data-dropdown-toggle="dropdown"
                className="dropdown-toggle align-middle inline-flex search-dropdown"
                type="button"
                onClick={() => setIsOpen(!isOpen)}
              >
                {navlight === true ? (
                  <>
                    <FiSearch className="size-5 dark-icon"></FiSearch>
                    <FiSearch className="size-5 white-icon text-white"></FiSearch>
                  </>
                ) : (
                  <FiSearch className="size-5"></FiSearch>
                )}
              </button>
              {isOpen && (
                <div
                  className={`dropdown-menu absolute overflow-hidden end-0 m-0 mt-5 z-10 md:w-52 w-48 rounded-md bg-white dark:bg-slate-900 shadow dark:shadow-gray-800`}
                >
                  <div className="relative">
                    <FiSearch className="absolute size-4 top-[9px] end-3 text-slate-900 dark:text-white"></FiSearch>
                    <input
                      type="text"
                      className="h-9 px-3 pe-10 w-full border-0 focus:ring-0 outline-none bg-white dark:bg-slate-900"
                      name="s"
                      id="searchItem"
                      placeholder="Search..."
                    />
                  </div>
                </div>
              )}
            </li>

            <li
              className="dropdown inline-block relative ps-0.5 hidden sm:block"
              ref={cartRef}
            >
              <button
                className="dropdown-toggle size-6 sm:size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full bg-green-500 hover:bg-gray-100 border border-green-500 text-white"
                type="button"
                onClick={() => navigate("/shop-cart")}
              >
                <FiShoppingCart className="h-4 w-4 sm:h-5 sm:w-5" />
              </button>
            </li>

            <li className="inline-block ps-0.5">
              <Link
                to="/wish-list"
                className="size-6 sm:size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full bg-green-500 hover:bg-gray-100 text-white"
              >
                <FiHeart data-feather="heart" className="h-4 w-4"></FiHeart>
              </Link>
            </li>

            <li className="dropdown inline-block relative ps-0.5" ref={userRef}>
              <button
                data-dropdown-toggle="dropdown"
                className="dropdown-toggle items-center"
                type="button"
                onClick={() => setUserManu(!userManu)}
              >
                <span className="size-6 sm:size-9 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-full border border-green-500 bg-green-500 text-white">
                  <img src={file} className="size-6 sm:size-9 rounded-full" alt="" />
                </span>
              </button>

              {userManu && (
                <div className="dropdown-menu absolute end-0 m-0 mt-4 z-10 w-48 rounded-md overflow-hidden bg-white dark:bg-slate-900 shadow dark:shadow-gray-700">
                  <ul className="py-2 text-start">
                    {!localStorage.getItem("customer_id") ? (
                      <>
                        <li className="ms-0">
                          <Link
                            to="/login"
                            className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-green-600 dark:hover:text-white"
                          >
                            <FiUser className="h-4 w-4 me-2" /> Login
                          </Link>
                        </li>
                        <li className="ms-0">
                          <Link
                            to="/signup"
                            className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-green-600 dark:hover:text-white"
                          >
                            <FiUser className="h-4 w-4 me-2" /> Signup
                          </Link>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="ms-0">
                          <p className="text-slate-400 pt-2 px-4">
                            Welcome {userName}!
                          </p>
                        </li>
                        <li className="ms-0">
                          <p className="flex items-center font-medium py-2 px-4">
                            <FaRupeeSign className="h-4 w-4 me-2" /> Balance:
                            <span className="text-green-500 ms-2">₹245.10</span>
                          </p>
                        </li>
                        <li className="ms-0">
                          <Link
                            to="/user-account"
                            className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-green-600 dark:hover:text-white"
                          >
                            <FiUser className="h-4 w-4 me-2" /> Account
                          </Link>
                        </li>
                        <li className="ms-0">
                          <Link
                            to="/helpcenter"
                            className="flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-green-600 dark:hover:text-white"
                          >
                            <FiHelpCircle className="h-4 w-4 me-2"></FiHelpCircle>{" "}
                            Helpcenter
                          </Link>
                        </li>
                        <li className="ms-0">
                          <button
                            onClick={handleLogout}
                            className="w-full text-left flex items-center font-medium py-2 px-4 dark:text-white/70 hover:text-green-600 dark:hover:text-white"
                          >
                            <FiLogOut className="h-4 w-4 me-2" /> Logout
                          </button>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              )}
            </li>

            <li>
              <LanguageSelector className="w-8 h-8 sm:w-10 sm:h-10" />
            </li>
          </ul>
          <div className="menu-extras ml-4">
            <div className="menu-item">
              <Link
                className={`navbar-toggle ${isToggle ? "open" : ""}`}
                id="isToggle"
                onClick={() => toggleMenu()}
              >
                <div className="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </ErrorBoundary>
  );
}
